import { BoardModel } from "Agile/Scripts/TFS.Agile.Boards";

export interface BoardData {
    boardId: string;
    teamId: string;
    backlogLevelId: string;
}

let boardData: BoardData;

/**
 * Allows NWP components to access the BoardModel data loaded on the board hub.
 * It is necessary since the board hub will remove the page data each time it is downloaded.
 */
export class BoardContextCache {
    public static setData(boardModel: BoardModel): void {
        boardData = {
            boardId: boardModel.board.id,
            teamId: boardModel.boardSettings.teamId,
            backlogLevelId: boardModel.boardSettings.backlogLevelId
        };
    }

    public static getData(): BoardData {
        return boardData;
    }
}
